import { render } from "./TeamLogo.vue?vue&type=template&id=109d2615&scoped=true"
import script from "./TeamLogo.vue?vue&type=script&lang=js"
export * from "./TeamLogo.vue?vue&type=script&lang=js"

import "./TeamLogo.vue?vue&type=style&index=0&id=109d2615&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109d2615"]])

export default __exports__